import * as React from "react";
import type { SVGProps } from "react";
const SvgSwitchButtonOn = (props: SVGProps<SVGSVGElement>) => <svg width={30} height={18} viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect width={30} height={18} rx={9} fill="#28C76F" /><circle cx={21} cy={9} r={6} fill="white" /></svg>;
export default SvgSwitchButtonOn;